import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './shared/auth/auth.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  {
    path: 'login',
    loadChildren: () => import('./features/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'RegisterUser/:org/:userID',
    loadChildren: () => import('./features/registration/registration.module').then((m) => m.RegistrationModule),
  },
  {
    path: 'NewPassword/:org/:userID',
    loadChildren: () => import('./features/forgot-password/forgot-password.module').then((m) => m.ForgotPasswordModule),
  },
  {
    path: 'ForgotPin/:userID',
    loadChildren: () => import('./features/forgot-pin/forgot-pin.module').then((m) => m.ForgotPinModule),
  },
  {
    path: 'RegisterAdmin/:userID',
    loadChildren: () => import('./features/admin-registration/admin-registration.module').then((m) => m.AdminRegistrationModule),
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./features/forgot-password/forgot-password.module').then((m) => m.ForgotPasswordModule),
  },
  {
    path: 'link-account',
    loadChildren: () => import('./features/link-account/link-account.module').then((m) => m.LinkAccountModule),
  },
  {
    path: 'license-expired',
    loadChildren: () => import('./features/license-expired/license-expired.module').then((m) => m.LicenseExpiredModule),
  },
  {
    path: 'not-found',
    loadChildren: () => import('./features/not-found/not-found.module').then((m) => m.NotFoundModule),
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    data: { role: 'superadmin' },
    loadChildren: () => import('./features/dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: 'org-list',
    canActivate: [AuthGuard],
    data: { role: 'superadmin' },
    loadChildren: () => import('./features/organisations-list/organisations-list.module').then((m) => m.OrganisationsListModule),
  },
  {
    path: 'org-detail',
    canActivate: [AuthGuard],
    data: { role: 'superadmin' },
    loadChildren: () => import('./features/organisation-detail/organisation-detail.module').then((m) => m.OrganisationDetailModule),
  },
  {
    path: 'course-detail',
    canActivate: [AuthGuard],
    data: { role: 'superadmin' },
    loadChildren: () => import('./features/course-detail/course-detail.module').then((m) => m.CourseDetailModule),
  },
  {
    path: 'module-editor',
    canActivate: [AuthGuard],
    data: { role: 'superadmin' },
    loadChildren: () => import('./features/module-editor/module-editor.module').then((m) => m.ModuleEditorModule),
  },
  {
    path: 'sequencing',
    canActivate: [AuthGuard],
    data: { role: 'superadmin' },
    loadChildren: () => import('./features/sequencing/sequencing.module').then((m) => m.SequencingModule),
  },
  {
    path: 'my-details',
    canActivate: [AuthGuard],
    data: { role: 'superadmin' },
    loadChildren: () => import('./features/my-details/my-details.module').then((m) => m.MyDetailsModule),
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    data: { role: 'admin' },
    loadChildren: () => import('./features/admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'user',
    canActivate: [AuthGuard],
    data: { role: 'user' },
    loadChildren: () => import('./features/user/user.module').then((m) => m.UserModule),
  },
  { path: '**', redirectTo: 'not-found' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { paramsInheritanceStrategy: 'always', })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
